import React from "react";
import "./PoliciesStyling.css";
import logo from "../../logo.png"; // adjust path if needed
import { useNavigate } from "react-router-dom";

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <main className="policy-page">
      <header className="policy-topbar">
        <button
          className="policy-back-btn"
          onClick={() => navigate(-1)}
          type="button"
        >
          Back
        </button>

        <div className="policy-brand">
          <img src={logo} alt="Kairos" className="policy-logo" />
          <span className="policy-brand-name">Kairos</span>
        </div>
      </header>

      <section className="policy-glass">
        <h1 className="policy-title">Privacy Policy</h1>
        <p className="policy-updated">Last updated: February 5, 2026</p>

        <div className="policy-section">
          <h2>1. Who we are</h2>
          <p>
            Kairos is an AI Website Builder that helps users create, edit, and publish websites.
            This Privacy Policy explains what we collect, why we collect it, and how you control it.
          </p>
        </div>

        <div className="policy-section">
          <h2>2. Information we collect</h2>
          <ul>
            <li>
              <strong>Account information:</strong> name, email address, profile photo (if you upload one).
            </li>
            <li>
              <strong>Workspace data:</strong> websites, pages, assets, settings, and content you create.
            </li>
            <li>
              <strong>Usage data:</strong> feature usage and events for product improvement and troubleshooting.
            </li>
            <li>
              <strong>Device and log data:</strong> basic device/browser signals used for security and performance.
            </li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>3. How we use your information</h2>
          <ul>
            <li>To provide and maintain the service (authentication, editing tools, publishing, storage).</li>
            <li>To improve reliability and performance (analytics, crash reports, diagnostics).</li>
            <li>To protect users and the platform (security monitoring, abuse prevention).</li>
            <li>To communicate with you based on your settings (billing, service alerts, optional product updates).</li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>4. Marketing communications and consent</h2>
          <p>
            If you opt in, we may send marketing messages (email/SMS/WhatsApp where available).
            You can change or withdraw marketing consent anytime in your Settings.
          </p>
        </div>

        <div className="policy-section">
          <h2>5. AI features and your content</h2>
          <p>
            When you use AI features, your prompts and content may be processed to generate outputs and
            improve the experience. Avoid submitting sensitive personal information in prompts.
          </p>
        </div>

        <div className="policy-section">
          <h2>6. Data sharing</h2>
          <p>
            We may share information with service providers needed to run Kairos (e.g., authentication,
            hosting, storage). We do not sell your personal information.
          </p>
        </div>

        <div className="policy-section">
          <h2>7. Data retention</h2>
          <p>
            We keep your account and workspace data while your account is active. You may request deletion.
            We may retain certain records where required for legal, billing, or security reasons.
          </p>
        </div>

        <div className="policy-section">
          <h2>8. Your rights and choices</h2>
          <ul>
            <li>Access and update your profile information.</li>
            <li>Update your notification and marketing preferences.</li>
            <li>Request deletion of your account (subject to legal/security limits).</li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>9. Contact</h2>
          <p>
            If you have questions about privacy, contact:{" "}
            <strong>developers@bakayise.com</strong>
          </p>
        </div>
      </section>

      <footer className="policy-footer">
        <p>© 2026 Kairos AI. All rights reserved.</p>
      </footer>
    </main>
  );
};

export default PrivacyPolicy;
